import { z as e } from "zod";
const u = e.record(e.unknown()), w = e.object({
  href: e.string(),
  rel: e.string().optional(),
  describedby: e.string().url().optional(),
  title: e.string().optional(),
  type: e.string().optional(),
  hreflang: e.string().optional(),
  meta: u.optional()
}), i = w.or(e.string()).nullable().optional(), R = e.record(i), h = e.object({
  self: i,
  related: i,
  describedby: i,
  first: i,
  prev: i,
  next: i,
  last: i
}), $ = e.object({
  id: e.string().optional(),
  links: e.object({
    about: i,
    type: i
  }).optional(),
  status: e.string(),
  code: e.string().optional(),
  title: e.string().optional(),
  detail: e.string().optional(),
  source: e.object({
    pointer: e.string().optional(),
    parameter: e.string().optional(),
    header: e.string().optional()
  }).optional(),
  meta: e.record(e.unknown()).optional()
}), D = e.object({
  errors: e.array($),
  meta: u.optional()
});
class v extends Error {
  constructor(n, o, c, a) {
    super(n), this.status = o, this.errors = c, this.meta = a;
  }
}
const T = async (t) => {
  var o;
  if (t.ok)
    return;
  if (!((o = t.headers.get("Content-Type")) != null && o.startsWith("application/vnd.api+json")))
    throw new Error("Failed to parse error response, invalid content type");
  const n = D.parse(await t.json());
  throw new v(
    `Failed to perform request to ${t.url}`,
    t.status,
    n.errors,
    n.meta
  );
}, A = /^page\[([a-zA-Z0-9]+)]$/, m = (t) => {
  if (t == null)
    return;
  const n = new URL(typeof t == "string" ? t : t.href, "http://localhost"), o = {};
  for (const [c, a] of n.searchParams.entries()) {
    const r = A.exec(c);
    r && (o[r[1]] = a);
  }
  if (Object.keys(o).length === 0)
    throw new Error(`No page params found in link ${n.toString()}`);
  return o;
}, C = (t, n) => {
  if (n)
    for (const [o, c] of Object.entries(n))
      t.searchParams.set(`page[${o}]`, c);
}, E = (t) => {
  const n = "resourceType" in t ? t.resourceType : t.include.type, o = e.object({
    id: e.string(),
    type: e.literal(n),
    meta: u.optional()
  });
  let c;
  switch (t.relationshipType) {
    case "one": {
      c = o;
      break;
    }
    case "one_nullable": {
      c = o.nullable();
      break;
    }
    case "many": {
      c = e.array(o);
      break;
    }
  }
  return e.object({
    links: R.optional(),
    meta: u.optional(),
    data: c
  }).transform((a) => ({
    ...a,
    deserializer: t
  }));
}, M = (t) => e.object(
  Object.fromEntries(
    Object.entries(t).map(([n, o]) => [
      n,
      E(o)
    ])
  )
), p = (t) => {
  const n = {
    id: e.string(),
    type: e.literal(t.type)
  };
  return t.attributesSchema && (n.attributes = t.attributesSchema), t.relationships && (n.relationships = M(t.relationships)), t.linksSchema && (n.links = t.linksSchema), t.metaSchema && (n.meta = t.metaSchema), e.object(n);
}, P = e.object({
  id: e.string(),
  type: e.string()
}).passthrough(), f = e.array(P), x = (t) => e.object({
  data: p(t),
  links: h.optional(),
  meta: t.documentMetaSchema ?? u.optional(),
  included: f.optional()
}), L = (t) => e.object({
  data: p(t).nullable(),
  links: h.optional(),
  meta: t.documentMetaSchema ?? u.optional(),
  included: f.optional()
}), O = (t) => e.object({
  data: e.array(p(t)),
  links: h.optional(),
  meta: t.documentMetaSchema ?? u.optional(),
  included: f.optional()
}), b = (t) => {
  var n;
  return new Map(
    ((n = t.included) == null ? void 0 : n.map((o) => [
      `${o.type}:::${o.id}`,
      { raw: o }
    ])) ?? []
  );
}, y = (t, n, o, c, a, r) => {
  const s = c.get(`${t}:::${n}`);
  if (!s)
    throw new Error(`No included resource with type ${t} and ID ${n} found`);
  if (s.processed)
    return s.processed;
  let l = a.get(o);
  return l || (l = p(r), a.set(o, l)), s.processed = d(
    l.parse(s.raw, { path: o.split(".") }),
    o,
    c,
    a
  ), s.processed;
}, F = (t, n, o, c) => {
  var r;
  if (t.data === null)
    return null;
  const a = "include" in t.deserializer ? t.deserializer.include : null;
  return a ? Array.isArray(t.data) ? t.data.map(
    (s) => y(a.type, s.id, n, o, c, a)
  ) : y(
    a.type,
    t.data.id,
    n,
    o,
    c,
    a
  ) : Array.isArray(t.data) ? t.data.map((s) => ({
    id: s.id,
    _meta: s.meta
  })) : {
    id: t.data.id,
    _meta: (r = t.data) == null ? void 0 : r.meta
  };
}, d = (t, n, o, c) => {
  const a = {
    id: t.id,
    ..."attributes" in t ? t.attributes : {}
  };
  if (t.links && (a.$links = t.links), t.meta && (a.$meta = t.meta), !t.relationships)
    return a;
  for (const [r, s] of Object.entries(t.relationships))
    a[r] = F(
      s,
      n ? `${n}.${r}` : r,
      o,
      c
    );
  return a;
}, g = (t, n, o) => {
  const c = { data: n };
  return t.links && o && (c.links = t.links), t.meta && (c.meta = t.meta), c;
}, _ = (t) => {
  const n = x(t), o = /* @__PURE__ */ new Map();
  return (c) => {
    const a = n.parse(c), r = b(a);
    return g(
      a,
      d(a.data, null, r, o),
      t.includeDocumentLinks
    );
  };
}, I = (t) => {
  const n = L(t), o = /* @__PURE__ */ new Map();
  return (c) => {
    const a = n.parse(c), r = b(a);
    return g(
      a,
      a.data === null ? null : d(a.data, null, r, o),
      t.includeDocumentLinks
    );
  };
}, J = (t) => {
  const n = O(t), o = /* @__PURE__ */ new Map();
  return (c) => {
    var s, l, S, k;
    const a = n.parse(c), r = b(a);
    return {
      ...g(
        a,
        a.data.map(
          (j) => d(j, null, r, o)
        ),
        t.includeDocumentLinks
      ),
      pageParams: {
        first: m((s = a.links) == null ? void 0 : s.first),
        prev: m((l = a.links) == null ? void 0 : l.prev),
        next: m((S = a.links) == null ? void 0 : S.next),
        last: m((k = a.links) == null ? void 0 : k.last)
      }
    };
  };
}, q = (t) => (n) => t(n).data;
export {
  v as JsonApiError,
  q as createDataSelector,
  I as createNullableResourceSelector,
  J as createResourceCollectionSelector,
  _ as createResourceSelector,
  R as defaultLinksSchema,
  T as handleJsonApiError,
  C as injectPageParams,
  w as linkObjectSchema,
  i as linkSchema,
  m as parsePageParamsFromLink
};
//# sourceMappingURL=index.js.map
